export default "__VITE_ASSET__ymoKaFuN__"